import axiosApiInstance from '../../../api/axiosClient';

export async function downloadBelieveMetadataExcel(
    params: Record<string, unknown>,
    filename = 'metadata-export.xlsx',
) {
    const response = await axiosApiInstance.post<Blob>(
        '/api/products/releases/export-believe-metadata',
        null,
        {
            params: {...params, is_pending: false},
            responseType: 'blob',
            skipErrorNotification: true,
        },
    );
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
